// This gets replaced with the version when running `pnpm run build`
const version = '111.4.1';
export default version;
